import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserProfileViewModel } from '../models/main/user-profile.model';
import { UserProfileStore } from '../stores/user-profile.store';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {
  public userProfileStore: UserProfileStore;
  private readonly _profile = new BehaviorSubject<UserProfileViewModel | null>(null);
  constructor() { }

  getLanguage() {
      if (navigator.language) {
        return navigator.language.substr(0, 2);
      } else {
        return "es";
      }
    }
  }
// }
